export default __webpack_public_path__ + "static/1-5a27d567b0a5ebf250679a821420ee4c.png";